import React, { Component } from 'react';
import PropTypes from 'prop-types';

import merge from 'lodash/merge';
import { defaultWarranty } from '@utils/recordHelpers';

import { PolarisFormProvider } from '@container';

import { WarrantyForm } from '@presentational';

const propTypes = {
  warranty: PropTypes.object.isRequired,
  update: PropTypes.bool,
  submitURL: PropTypes.string.isRequired,
};

const defaultProps = {
  update: false,
}

class WarrantyFormWrapper extends Component {
  constructor(props) {
    super(props);
    this.state= {
      //...defaultValues // When using polaris instead of formik
      defaultValues: props.update ? props.warranty : merge(props.warranty, defaultWarranty),
      method: props.update ? "PATCH" : "POST",
    }
  }

  render() {
    let { defaultValues, method } = this.state;
    let { submitURL, deleteURL } = this.props;
    return (
      <PolarisFormProvider
        title={ I18n.t("activerecord.models.warranty.one") }
        defaultValues={ defaultValues }
        submitURL={ submitURL }
        submitMethod={ method }
        pageProps={{
          breadcrumbs: [{content: I18n.t("actions.back"), url: '/admin/warranties'}]
        }}
        >
      { (renderProps) =>
        <WarrantyForm deleteURL={ deleteURL } {...renderProps} />
      }
      </PolarisFormProvider>
    );
  }
}


WarrantyFormWrapper.propTypes = propTypes;
WarrantyFormWrapper.defaultProps = defaultProps;


export default WarrantyFormWrapper;
